import { render, staticRenderFns } from "./curingOrders.vue?vue&type=template&id=597338fa&scoped=true"
import script from "./curingOrders.vue?vue&type=script&lang=js"
export * from "./curingOrders.vue?vue&type=script&lang=js"
import style0 from "./curingOrders.vue?vue&type=style&index=0&id=597338fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597338fa",
  null
  
)

export default component.exports